<template>
  <div class="wrap">
    <div class="common-title">{{title}}</div>
    <div class="other" v-if="slotArr&&slotArr.length>0">
      <div
        v-for="(item,index) in slotArr"
        :key="index"
        class="slot-item"
        @click="toSearch(item)"
      >{{item}}</div>
    </div>
    <div v-if="showMore" class="look-more">
      {{$t('viewMore')}}
      <i class="icon iconfont iconmore"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: "TitleSlot",
  components: {},
  props: {
    title: {
      type: String,
      default: ""
    },
    slotArr: Array,
    showMore: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  methods: {
    toSearch(item) {
      this.$router.push({
        name: "search",
        // query: { key: item, name: item }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@/assets/css/variable.scss";
.wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  padding-top: 20px;
  .common-title {
    width: 400px;
    height: 24px;
    line-height: 24px;
    font-size: 22px;
    font-weight: 200;
    color: #333;
  }
  .other {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .slot-item {
      margin-left: 30px;
      font-size: 14px;
      height: 24px;
      line-height: 24px;
      cursor: pointer;
      transition: border-color 0.5s;
      border-bottom: 2px solid transparent;
      &:hover {
        color: $theme-color;
        border-bottom: 2px solid $theme-color;
      }
    }
  }
  .look-more {
    font-size: 14px;
    cursor: pointer;
    &:hover {
      color: $theme-color;
      .icon {
        color: $theme-color;
      }
    }
    .icon {
      color: #b0b0b0;
      margin-left: 4px;
    }
  }
}
</style>